import { SendSMSTemplate } from 'views/templates/sendSMS';
import { Toast } from 'views/mutual/toast';
import { useUpdateMail } from './hooks'
import { TemplateProps } from '../common';

export const UpdateSendMail = (props: TemplateProps) => {
    const { toastProps, certificatePage } = useUpdateMail(props);

    return(
        <>
        <SendSMSTemplate {...certificatePage} toastProps={toastProps} />

        <Toast {...toastProps} />
        </>
    );
}